import { Callout } from '@/components/Callout'
import { Hero } from '@/components/Hero'
import { Map, MapItem } from '@/components/Map'
import { laravelGraphqlEndpoint } from '@/globals/globals'
import { getPrefixedStorageURL } from '@/lib/getPrefixedStorageURL'
import { parseJSONinObject } from '@/lib/parseJSONinObject'
import { Project } from '@/types/project'
import { Stack } from '@chakra-ui/react'
import { gql, request } from 'graphql-request'

export async function getStaticProps() {
  let projectsQuery = await request(
    laravelGraphqlEndpoint,
    gql`
      {
        memberProjectsOnMap(published: true, show_on_map: true) {
          uuid
          title
          lat
          lng
          images
          slug
        }
      }
    `
  )

  const projectsParsed = projectsQuery.memberProjectsOnMap.map(
    (project: Project): Project => parseJSONinObject(project)
  )

  const mapItems = projectsParsed
    .map((project: Project): MapItem | null => {
      if (!project.lng || !project.lat) return null

      return {
        slug: project.slug ?? '',
        title: project.title,
        lng: project.lng,
        lat: project.lat,
        image:
          project.images && project.images.length > 0
            ? getPrefixedStorageURL(project.images[0]?.path, 'imgkit') +
              '?tr=n-thumbnail'
            : '/img/image-placeholder.png',
      }
    })
    .filter((item: MapItem | null): item is MapItem => item !== null)

  return {
    props: {
      mapItems,
    },
    revalidate: 20,
  }
}

export default function Page(props: { mapItems: MapItem[] }) {
  return (
    <>
      <Hero heading='Projects around the world'></Hero>
      <Map
        items={props.mapItems}
        itemType='Project'
        sectionUrl='/nation/projects/'
      />
      <Stack
        spacing={8}
        py={8}
        px={4}
        maxWidth='6xl'
        mx='auto'
        direction={{ base: 'column', xl: 'row' }}>
        <Callout
          href='/membership'
          title='Add Your Project'
          subheading='Want to add your project to the map? Become a member today and get your project featured.'
        />
        <Callout
          href='/nation/map/garages'
          title='Garage Map'
          subheading='Looking for a local shop to help you with your project? Check out our map of garages around the world.'
        />
      </Stack>
    </>
  )
}
